import { render, staticRenderFns } from "./ProjectSolarPlant.vue?vue&type=template&id=927d30ea"
import script from "./ProjectSolarPlant.vue?vue&type=script&lang=js"
export * from "./ProjectSolarPlant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports